// extracted by mini-css-extract-plugin
module.exports = {"container":"QRCode_container__123v2","qrCode":"QRCode_qrCode__W14PK"};